// extracted by mini-css-extract-plugin
module.exports = {"root":"ReaderModeOnlyElement_root__6Qn2e"};